import React from 'react';
import QrPrint from './QrPrint';
import './QrSection.css';

// The QR code area on an item or place page: collapsed until opened, so it does
// not take up the page. Opening it shows the sizes and the Print button.
function QrSection({ qrCode, name, noun }) {
  if (!qrCode) return null;
  return (
    <details className="qr-collapsible">
      <summary>Print QR code for this {noun}</summary>
      <QrPrint qrCode={qrCode} name={name} />
    </details>
  );
}

export default QrSection;
